export default __webpack_public_path__ + "static/media/Fats.ddb0d426.jpg";